<template>
  <div class="container-fluid main-content">
    <student-search-bar/>
    <br><br> 
    <detention-list />
    <br><br>
    <hr>
  </div>
</template>

<script>
import DetentionList from '@/components/DetentionList.vue'
import StudentSearch from '@/components/StudentSearch.vue'

export default {
    name: "Detentions",
    components : {
        "detention-list": DetentionList,
        "student-search-bar": StudentSearch
    },
}
</script>
